import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/motion";

export default function AssessCta() {
  return (
    <section className="bg-white text-ink sec" data-testid="assessment-cta-section">
      <div className="wrap max-w-3xl">
        <Reveal>
          <p className="eyebrow text-gold flex items-center gap-3 mb-6">
            Assess your ESG & Sustainability maturity <span className="hidden sm:block h-px w-14 bg-gold/60" />
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="h-display font-bold text-[32px] sm:text-5xl lg:text-[56px] leading-[1.06]">
            Where does your organisation stand?
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="text-ink/70 text-[15.5px] sm:text-lg leading-relaxed max-w-xl mt-7" data-testid="assessment-cta-copy">
            Answer a few questions and understand your current ESG and sustainability maturity across Environment, Social and Governance.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <Link to="/esg-readiness-assessment" className="btn-gold px-8 py-4 mt-10" data-testid="assessment-cta-button">
            Start Assessment <ArrowRight size={16} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
